import { mapState, mapGetters } from 'vuex';
import coupon from '@mixins/officialTopup/coupon';
import {
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  UPDATE_HAS_SELECT_PRODUCT
} from '@store/officialTopup';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV3';
export default {
  mixins: [coupon],
  computed: {
    ...mapState({
      hasLoadPaytype: state => state.hasLoadPaytype,
      canUseCart: state => state.cart.canUseCart,
      cartList: state => state.cart.cartList,
      gameId: state => state.gameId
    }),
    ...mapGetters(['cartTotalQuantity', 'isCart']),
    hasValidGameCoupon() {
      return this.gameCouponEnableList?.length > 0;
    },
    showUseCartGuideTip() {
      if (
        this.hasLoadPaytype &&
        this.canUseCart &&
        this.hasValidGameCoupon &&
        (!this.isCart || (this.isCart && this.cartTotalQuantity === 1))
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleUseCartGuide() {
      clickButton({
        btnName: 'go_addon_product'
      });
      this.reSelectProduct();
    },
    handleReSelectProduct() {
      clickButton({
        btnName: 'back_select_product',
        locationKey: locationType.selectProduct
      });
      this.reSelectProduct();
    },
    reSelectProduct() {
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
    }
  }
};
